// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FORM SUCCESS SCROLL


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


//
// =FORM SUCCESS SCROLL
// --------------------------------------------------

var form = document.getElementById('section_participate');

if (form) {
  console.log('form is here');
  var observerForm = new MutationObserver(function (event) {
    console.log(event);
    $("html, body").animate({
        scrollTop: $('#section_participate').offset().top - 64,
      }, 500);
    console.log('form after animate');
  });

  observerForm.observe(form, {
    attributes: true,
    attributeFilter: ['class', 'data-state'],
    childList: false,
    characterData: false
  });
}
